jQuery(document).ready(function($) {
    $('a').on('click', function (e) {
        let href = $(this).attr('href');
        if (!href) return;

        let hash = href.includes('#') ? href.slice(href.indexOf('#')) : null;
        if (!hash) return;

        // same page only
        if (location.pathname === '/' || href.startsWith('#')) {
            const $target = $(hash);
            if (!$target.length) return;

            e.preventDefault();

            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 1500);
        }
    });



    if (window.location.hash) {
    const $target = $(window.location.hash);

    if ($target.length) {
        // cancel native jump
        $(window).scrollTop(0);

        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 500);
        }, 0);
    }
}


    function reorderMasonryItems(gridElem, items, ordering) {
        items.sort(function(a, b) {
            return $(a).data(ordering) - $(b).data(ordering);
        });

        items.each(function() {
            $(gridElem).append($(this));
        });
    }

    let masonry_containers = $('.masonry-gallery-container');

    if (masonry_containers.length) {
        masonry_containers.each(function() {
            let gridElem = $(this).get(0);

            let $grid = new Packery(gridElem, {
                itemSelector: '.grid-item',
                percentPosition: true,
                gutter: '.gutter-sizer',
            });

            imagesLoaded($grid).on('progress', function() {
                $grid.layout();
            });

            let $items = $(gridElem).find('.grid-item');

            // Track current breakpoint
            let isMobile = $(window).width() <= 600;

            function reorderForBreakpoint() {
                if (isMobile) {
                    reorderMasonryItems(gridElem, $items, 'mobile-item-order');
                } else {
                    reorderMasonryItems(gridElem, $items, 'desktop-item-order');
                }
                $grid.reloadItems();
                $grid.layout();
            }

            // Initial layout
            reorderForBreakpoint();

            // Debounced resize
            let debounce = function(func, wait = 150) {
                let timeout;
                return function(...args) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(this, args), wait);
                };
            };

            $(window).on('resize', debounce(function() {
                let currentlyMobile = $(window).width() <= 600;

                // Only reorder if breakpoint changed
                if (currentlyMobile !== isMobile) {
                    isMobile = currentlyMobile;
                    reorderForBreakpoint();
                }
            }));
        });
    }

    function setEqualHeight(slider) {
        let maxHeight = 0;
        slider.find('.slick-slide').each(function() {
            $(this).css('height', 'auto');

            if ($(this).height() > maxHeight) {
                maxHeight = $(this).height();
            }
        });

        slider.find('.slick-slide').height(maxHeight);
    }

    if($('.flip-cards-container').length) {
        $('.flip-cards-container').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            infinite: true,
            swipe: true,
            touchMove: true, 
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 917,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1171,
                    settings: "unslick",
                }
            ]
        });

        $('.flip-cards-container').on('setPosition', function() {
            setEqualHeight($(this));
        });

        setEqualHeight($('.flip-cards-container'));
    }
    
    if($('.brands-list').length) {
        $('.brands-list').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            infinite: true,
            swipe: true,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });

        $('.brands-list').on('setPosition', function() {
            setEqualHeight($(this));
        });

        setEqualHeight($('.brands-list'));
    }

    function replaceBracketsInTextNodes($container, spanClass) {
        var walker = document.createTreeWalker(
            $container[0],
            NodeFilter.SHOW_TEXT,
            null,
            false
        );

        var nodes = [];
        while (walker.nextNode()) {
            nodes.push(walker.currentNode);
        }

        nodes.forEach(function(textNode) {
            var text = textNode.nodeValue;

            if (!/\[[^\]]+\]/.test(text)) return;

            var replaced = text.replace(/\[([^\]]+)\]/g, function(_, inner) {
                return '<span' + (spanClass ? ' class="' + spanClass + '"' : '') + '>' + inner + '</span>';
            });

            var wrapper = document.createElement('div');
            wrapper.innerHTML = replaced;

            var fragment = document.createDocumentFragment();
            while (wrapper.firstChild) {
                fragment.appendChild(wrapper.firstChild);
            }

            textNode.parentNode.replaceChild(fragment, textNode);
        });
    }

    const targetSelector = '.cky-notice-des p';

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.matches(targetSelector)) {
                    replaceBracketsInTextNodes($(node), 'bracketed');
                }

                if (node.nodeType === 1 && node.querySelector) {
                    const found = node.querySelector(targetSelector);
                    if (found) {
                    replaceBracketsInTextNodes($(found), 'bracketed');
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    if($('.tabs').length) {
        $('.tabs').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            swipe: true,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 620,
                    settings: "unslick"
                }
            ]
        })
    }

    const targetSelector_two = '.drawer--root .cart--root';
    const locale = window.Shopify.routes.root;
    const currency_code = window.Shopify.currency.active;

    async function populate_cart_complementary_products() {
        const cart = await fetch(`${locale}cart.js`);
        const cart_json = await cart.json();

        let cart_product_recommendations_html = "";
        $('.cart-product-recommendations').html('');

        for (const item of cart_json['items']) {
            let product_recommendations = await fetch(`${locale}recommendations/products.json?product_id=${item.product_id}&intent=complementary&limit=5`);
            let product_recommendations_json = await product_recommendations.json();

            for(const recomm of product_recommendations_json.products) {
                let formattedAmount = new Intl.NumberFormat(undefined, {
                    style: 'currency',
                    currency: currency_code,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(recomm.price / 100);

                cart_product_recommendations_html += `
                    <div class="product-recommendation">
                        <a href="${recomm.url}">
                            <img src="${recomm.featured_image}" alt="" width="166" height="199" />
                            <div class="product-recommendation-info">
                                <p class="price">${formattedAmount}</p>
                                <p class="title">${recomm.title}</p>
                            </div>
                        </a>
                    </div>
                    `; 
            }  
        }
        if(cart_product_recommendations_html != '') {
            $('.cart-product-recommendations-container').show();
            $('.cart-product-recommendations').append(cart_product_recommendations_html);
        } else {
            $('.cart-product-recommendations-container').hide();
            $('.cart-product-recommendations').html('');
        }
        
    }

    populate_cart_complementary_products();

    const observer_two = new MutationObserver(async (mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && node.classList.contains('cart--body')) {
                        populate_cart_complementary_products();
                    }
                }
            }
        }
    });

    observer_two.observe(document.querySelector(targetSelector_two), {
        childList: true,
        subtree: true,
        attributes: true
    });

    if($('.edit-address').length) {
        $('.edit-address').on('click', function(event) {
            let current_table = $(this).parents('.address--table');

            $('.address--table').not(current_table).hide();
            $('.add-new-address-container').hide();
            $('#add_address').hide();
        });
    }

    if($('.address--button-container a').length) {
        $('.address--button-container a').on('click', function(event) {
            let current_table = $(this).parents('.address--table');
            let check_if_new_address_form = $(this).parents('#add_address');

            $('.address--table').not(current_table).show();
            $('.add-new-address-container').show();

            if(check_if_new_address_form.length == 0) {
                $('#add_address').hide();
            }
        });
    }

    if($('.add-new-address').length) {
        $('.add-new-address').on('click', function(event) {
            $('.address--table').hide();
            $('.add-new-address-container').hide();
        });
    }

    function initTestimonialsSlick() {
        if ($('.testimonials--body').length) {
            if ($(window).width() < 768) {
                if (!$('.testimonials--body').hasClass('slick-initialized')) {
                    $('.testimonials--body').slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    infinite: true,
                    swipe: true,
                    touchMove: true,
                    responsive: [
                        {
                        breakpoint: 768,
                        settings: "unslick"
                        }
                    ]
                    });
                }
            } else {
                if ($('.testimonials--body').hasClass('slick-initialized')) {
                    $('.testimonials--body').slick('unslick');
                }
            }
        }
    }

    initTestimonialsSlick();

    let testimonialsResizeTimer;
    $(window).on('resize', function () {
        clearTimeout(testimonialsResizeTimer);
        testimonialsResizeTimer = setTimeout(initTestimonialsSlick, 150);
    });

    const DEFAULT_LENGTH = 120;
    const MOBILE_MAX_WIDTH = 767;
    function applyReadMore() {
        const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;

        $('.custom-read-more').each(function () {
            const $el = $(this);

            if (!$el.data('original-text')) {
                $el.data('original-text', $.trim($el.text()));
            }

            const fullText = $el.data('original-text');
            const maxLength = parseInt($el.data('read-more-length'), 10) || DEFAULT_LENGTH;

            if (!isMobile) {
                $el.text(fullText);
                $el.removeData('truncated expanded');
                return;
            }

            if ($el.data('expanded')) return;
            if (fullText.length <= maxLength) return;
            if ($el.data('truncated')) return;

            const truncatedText = fullText.slice(0, maxLength).trim() + '...';

            const $readMore = $('<span>', {
                class: 'custom-read-more__link',
                text: 'Read more'
            });

            $el.data('truncated', true)
                .text(truncatedText)
                .append($readMore);

            $readMore.on('click', function () {
                $el.data('expanded', true)
                .text(fullText);
            });
        });
    }

    applyReadMore();

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyReadMore, 150);
    });

    jQuery(document).on('click', '.logout-link', function (e) {
        e.preventDefault()
        window.location.href = jQuery(this).data('logoutUrl')
    })
});